<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                      <el-table
                      v-loading="isLoading"
                    :data="tableData"
                    :height="bodyHeight"
                        style="width: 100%">
                        <el-table-column type="expand">
                        <template slot-scope="scope">
                            <div>
                                <el-form label-position="left" inline class="demo-table-expand">
                                <el-form-item  label="利润明细">
                                    <el-link @click="selIndex=1" :type="selIndex==1?'primary':'info'" style="margin-right:5px">
                                        <i class="el-icon-s-opportunity"></i>
                                    </el-link>

                                    <el-tag size="small" :type="selIndex!=1?'info':'danger'" >佣金收  {{scope.row.CommissionIncome.toFixed(2) }}</el-tag>
                                   +
                                   <el-tag size="small" :type="selIndex!=1?'info':'danger'" >好评收  {{scope.row.PraiseIncome.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="selIndex!=1?'info':'success'" >佣金支  {{scope.row.CommissionExpense.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="selIndex!=1?'info':'success'" >好评支  {{scope.row.PraiseExpense.toFixed(2) }}</el-tag>
                                   +
                                   <el-tag size="small"  :type="scope.row.AssetRecovery==0||selIndex!=1?'info':'danger'" >资损追回  {{scope.row.AssetRecovery.toFixed(2) }}</el-tag>
                                    +
                                   <el-tag size="small" :type="scope.row.OperatingIncome==0||selIndex!=1?'info':'danger'"  >线下收入  {{scope.row.OperatingIncome.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="scope.row.MemberExpense==0||selIndex!=1?'info':'success'" >商家推广  {{scope.row.MemberExpense.toFixed(2) }}</el-tag>
                                   -
                                   
                                   <el-tag size="small" :type="scope.row.SwipeExpense==0||selIndex!=1?'info':'success'" >会员推广  {{scope.row.SwipeExpense.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="scope.row.SwipeReward==0||selIndex!=1?'info':'success'" >会员奖励  {{scope.row.SwipeReward.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="scope.row.SwipeAbnormal==0||selIndex!=1?'info':'success'" >订单撤销  {{scope.row.SwipeAbnormal.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="scope.row.OutsiderAbnormal==0||selIndex!=1?'info':'success'" >财务多转  {{scope.row.OutsiderAbnormal.toFixed(2) }}</el-tag>
                                   -
                                   <br/>
                                   <el-tag style="margin-left:148px" size="small" :type="scope.row.MemberAbnormal==0||selIndex!=1?'info':'success'" >商家赔付  {{scope.row.MemberAbnormal.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="(scope.row.FinanceWage+scope.row.ReviewWage+scope.row.Reimbursement)==0||selIndex!=1?'info':'success'" >线下支出  {{(scope.row.FinanceWage+scope.row.ReviewWage+scope.row.Reimbursement).toFixed(2) }}</el-tag>
                                   +
                                   <el-tag size="small" :type="(scope.row.OtherIncome==0||selIndex!=1)?'info':'danger'" >运营收入  {{(scope.row.OtherIncome).toFixed(2) }}</el-tag>
                                </el-form-item>
                                <el-divider></el-divider>
                                <el-form-item label="现金收支">
                                    <el-link @click="selIndex=2" :type="selIndex==2?'primary':'info'" style="margin-right:5px">
                                        <i class="el-icon-s-opportunity"></i>
                                    </el-link>

                                  <el-tag size="small" :type="selIndex!=2?'info':'warning'"  >昨日现金  {{scope.row.YesterdayCash.toFixed(2) }}</el-tag>
                                  +
                                   <el-tag size="small" :type="selIndex!=2?'info':'danger'" >商家充值  {{scope.row.MemberRecharge.toFixed(2) }}</el-tag>
                                   -
                                    
                                   <el-tag size="small" :type="scope.row.MemberWithdrawal==0||selIndex!=2?'info':'success'" >商家提现  {{scope.row.MemberWithdrawal.toFixed(2) }}</el-tag>
                                   +
                                   <el-tag size="small" :type="scope.row.AssetRecovery==0||selIndex!=2?'info':'danger'"  >资损追回  {{scope.row.AssetRecovery.toFixed(2) }}</el-tag>
                                    +
                                   <el-tag size="small" :type="scope.row.OutsiderReturn==0||selIndex!=2?'info':'danger'" >出纳转回  {{scope.row.OutsiderReturn.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="selIndex!=2?'info':'success'" >转给出纳  {{scope.row.OutsiderRecharge.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="(scope.row.FinanceWage+scope.row.ReviewWage+scope.row.Reimbursement)==0||selIndex!=2?'info':'success'" >线下支出  {{(scope.row.FinanceWage+scope.row.ReviewWage+scope.row.Reimbursement).toFixed(2) }}</el-tag>
                                +
                                   <el-tag size="small" :type="(OperatingIncome||selIndex!=2)?'info':'danger'" >线下收入  {{(scope.row.OperatingIncome).toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="(scope.row.PutOutCost)==0||selIndex!=2?'info':'success'" >外放支出  {{(scope.row.PutOutCost).toFixed(2) }}</el-tag>
                                </el-form-item>
                                 <el-divider></el-divider>
                                <el-form-item label="出纳收支">
                                    <el-link @click="selIndex=3" :type="selIndex==3?'primary':'info'" style="margin-right:5px">
                                        <i class="el-icon-s-opportunity"></i>
                                    </el-link>

                                  <el-tag size="small" :type="selIndex!=3?'info':'warning'" >昨日结余  {{scope.row.YesterdayOutsiderCash.toFixed(2) }}</el-tag>
                                  +
                                   <el-tag size="small" :type="selIndex!=3?'info':'danger'" >转给出纳  {{scope.row.OutsiderRecharge.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="scope.row.OutsiderReturn==0||selIndex!=3?'info':'success'" >出纳转回  {{scope.row.OutsiderReturn.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="selIndex!=3?'info':'success'" >人工提现  {{scope.row.SwipeWithdrawal.toFixed(2) }}</el-tag>
                                    -
                                   <el-tag size="small" :type="selIndex!=3?'info':'success'" >自动提现  {{scope.row.AutoWithdrawal.toFixed(2) }}</el-tag>
                                    
                                    -
                                    <el-tag size="small" :type="scope.row.OutsiderAbnormal==0||selIndex!=3?'info':'success'" >财务多转  {{scope.row.OutsiderAbnormal.toFixed(2) }}</el-tag>
                                    = 
                                    <el-tag size="small" :type="selIndex!=3?'info':''" >预期出纳余额  {{scope.row.ExpectedOutsiderCash.toFixed(2) }}</el-tag>

                                </el-form-item>
                                 <el-divider></el-divider>
                                <el-form-item label="商家收支">
                                    <el-link @click="selIndex=4" :type="selIndex==4?'primary':'info'" style="margin-right:5px">
                                        <i class="el-icon-s-opportunity"></i>
                                    </el-link>

                                  <el-tag size="small" :type="selIndex!=4?'info':'warning'" >昨日结余  {{scope.row.YesterdayMemberBalance.toFixed(2) }}</el-tag>
                                  -
                                   <el-tag size="small" :type="selIndex!=4?'info':'success'" >昨日应收  {{scope.row.YesterdayMemberRevenue.toFixed(2) }}</el-tag>
                                    +
                                   <el-tag size="small" :type="selIndex!=4?'info':'danger'" >充值  {{scope.row.MemberRecharge.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="scope.row.MemberWithdrawal==0||selIndex!=4?'info':'success'" >提现  {{scope.row.MemberWithdrawal.toFixed(2) }}</el-tag>
                                   -
                                     <el-tag size="small" :type="scope.row.MemberTaskDeduction==0||selIndex!=4?'info':'success'" >任务扣款  {{scope.row.MemberTaskDeduction.toFixed(2) }}</el-tag>
                                    -
                                    <el-tag size="small" :type="scope.row.PraiseIncome==0||selIndex!=4?'info':'success'" >好评扣款  {{scope.row.PraiseIncome.toFixed(2) }}</el-tag>
                                    +
                                    <el-tag size="small" :type="scope.row.MemberTaskRefund==0||selIndex!=4?'info':'danger'" >任务退款  {{scope.row.MemberTaskRefund.toFixed(2) }}</el-tag>
                                     -
                                    <el-tag size="small" :type="scope.row.MemberTaskMakeUp==0||selIndex!=4?'info':'success'" >任务补扣  {{scope.row.MemberTaskMakeUp.toFixed(2) }}</el-tag>
                                    +
                                    <el-tag size="small" :type="scope.row.MemberOrderRevoke==0||selIndex!=4?'info':'danger'" >订单撤销  {{scope.row.MemberOrderRevoke.toFixed(2) }}</el-tag>
                                     +
                                    <el-tag size="small" :type="scope.row.MemberExpense==0||selIndex!=4?'info':'danger'" >推广收入  {{scope.row.MemberExpense.toFixed(2) }}</el-tag>
                                    +
                                    <br/>
                                    <el-tag  style="margin-left:162px" size="small" :type="scope.row.MemberRevenue==0||selIndex!=4?'info':'danger'" >今日应收  {{scope.row.MemberRevenue.toFixed(2) }}</el-tag>
                                    =
                                   <el-tag size="small" :type="selIndex!=4?'info':''" >预期商家余额  {{scope.row.ExpectedMemberBalance.toFixed(2) }}</el-tag>
                                    
                                </el-form-item>
                                 <el-divider></el-divider>
                                <el-form-item label="刷手收支">
                                    <el-link @click="selIndex=5" :type="selIndex==5?'primary':'info'" style="margin-right:5px">
                                        <i class="el-icon-s-opportunity"></i>
                                    </el-link>

                                  <el-tag size="small" :type="selIndex!=5?'info':'warning'" >昨日结余  {{scope.row.YesterdaySwipeBalance.toFixed(2) }}</el-tag>
                                  -
                                   <el-tag size="small" :type="selIndex!=5?'info':'success'" >昨日欠款  {{scope.row.YesterdaySwipeArrears.toFixed(2) }}</el-tag>
                                    +
                                   <el-tag size="small" :type="selIndex!=5?'info':'danger'" >本金收入  {{scope.row.SwipePrincipal.toFixed(2) }}</el-tag>
                                   +
                                   <el-tag size="small" :type="selIndex!=5?'info':'danger'" >佣金收入  {{scope.row.CommissionExpense.toFixed(2) }}</el-tag>
                                   +
                                   <el-tag size="small" :type="scope.row.OtherCost==0||selIndex!=5?'info':'danger'" >其它佣金  {{scope.row.OtherCost.toFixed(2) }}</el-tag>
                                   +
                                   <el-tag size="small" :type="selIndex!=5?'info':'danger'" >推广收入  {{scope.row.SwipeExpense.toFixed(2) }}</el-tag>
                                   +
                                   <el-tag size="small" :type="scope.row.好评收入==0||selIndex!=5?'info':'danger'" >好评收入  {{scope.row.PraiseExpense.toFixed(2) }}</el-tag>
                                   +
                                   <el-tag size="small" :type="scope.row.SwipeReward==0||selIndex!=5?'info':'danger'" >奖励收入  {{scope.row.SwipeReward.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="scope.row.SwipeWithdrawal==0||selIndex!=5?'info':'success'" >人工提现  {{scope.row.SwipeWithdrawal.toFixed(2) }}</el-tag>
                                   -
                                   <el-tag size="small" :type="scope.row.AutoWithdrawal==0||selIndex!=5?'info':'success'" >自动提现  {{scope.row.AutoWithdrawal.toFixed(2) }}</el-tag>
                                   -
                                    <el-tag size="small" :type="scope.row.SwipeAbnormal==0||selIndex!=5?'info':'success'" >撤销订单  {{scope.row.SwipeAbnormal.toFixed(2) }}</el-tag>
                                    -
                                    <br/>
                                    <el-tag size="small" style="margin-left:162px" :type="scope.row.OutsiderAbnormal==0||selIndex!=5?'info':'success'" >财务多转  {{scope.row.OutsiderAbnormal.toFixed(2) }}</el-tag>
                                    +
                                    <el-tag size="small" :type="scope.row.AssetRecovery==0||selIndex!=5?'info':'danger'" >资损追回{{scope.row.AssetRecovery.toFixed(2) }}</el-tag>
                                    +
                                    <el-tag  size="small" :type="scope.row.SwipeSpecialExpenses==0||selIndex!=5?'info':''" >特殊项  {{scope.row.SwipeSpecialExpenses.toFixed(2) }}</el-tag>
                                    -
                                    <el-tag size="small" :type="scope.row.SwipeTaskMakeUp==0||selIndex!=5?'info':'success'" >任务补扣  {{scope.row.SwipeTaskMakeUp.toFixed(2) }}</el-tag>
                                    +
                                    <el-tag size="small" :type="scope.row.SwipeTaskMakeRefund==0||selIndex!=5?'info':'danger'" >任务补回  {{scope.row.SwipeTaskMakeRefund.toFixed(2) }}</el-tag>
                                    +
                                    <el-tag size="small" :type="scope.row.SwipeArrears==0||selIndex!=5?'info':'danger'" >今日欠款  {{scope.row.SwipeArrears.toFixed(2) }}</el-tag>
                                    =
                                   <el-tag size="small" :type="selIndex!=5?'info':''" >预期会员余额  {{scope.row.ExpectedSwipeBalance.toFixed(2) }}</el-tag>
                                    
                                </el-form-item>
                                <el-divider></el-divider>
                                 <el-form-item  label="备注">
                                     <el-input
                                     style="width:1000px;margin-left:23px"
                                        type="textarea"
                                        :rows="5"
                                        placeholder="请输入备注"
                                        v-model="scope.row.Remark">
                                        </el-input>
                                          <el-button style="margin-left:20px" size="small" type="primary" @click="saveRemark(scope.row)">保存</el-button>

                                 </el-form-item>
                                </el-form>
                            </div>
                        </template>
                        </el-table-column>
                        <el-table-column
                        label="日期">
                            <template slot-scope="scope">
                                <i class="el-icon-time"></i>
                                <span style="margin-left:5px" >{{ scope.row.Date.split(' ')[0] }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                        label="总资产">
                            <template slot-scope="scope">
                                <el-tag  effect="plain"  type="warning" >
                                     <i class="el-icon-coin" style="margin-right:5px"></i>
                                    {{scope.row.TotalAssets.toFixed(2) }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                        label="利润">
                            <template slot-scope="scope">
                                <el-tag  effect="plain" type="danger">
                                     <i class="el-icon-money" style="margin-right:5px"></i>
                                    {{scope.row.Profit.toFixed(2) }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                        label="现金">
                            <template slot-scope="scope">
                                <el-tag  effect="plain"  >
                                     <i class="el-icon-money" style="margin-right:5px"></i>
                                    {{scope.row.Cash.toFixed(2) }}</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column
                        label="出纳余额">
                            <template slot-scope="scope">
                                    {{scope.row.OutsiderCash.toFixed(2) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                        label="商家余额">
                            <template slot-scope="scope">
                                
                                    {{scope.row.MemberBalance.toFixed(2) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                        label="会员余额">
                            <template slot-scope="scope">
                              
                                    {{scope.row.SwipeBalance.toFixed(2) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                        label="商家应收">
                            <template slot-scope="scope">
                                    {{scope.row.MemberRevenue.toFixed(2) }}
                            </template>
                        </el-table-column>

                        <el-table-column
                        label="商家预付">
                            <template slot-scope="scope">
                               
                                    {{scope.row.MmeberPrepaid.toFixed(2) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                        label="商家赔付余额">
                            <template slot-scope="scope">

                                    {{scope.row.MemberIndemnity.toFixed(2) }}
                            </template>
                        </el-table-column>

                        
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<style>

  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }

</style>
<script>
import { statisticsGetDaily,statisticsSaveRemark} from '@/request.js'

 import moment from 'moment';
export default {
    data(){
        return {
            bodyHeight:0,
            isLoading:false,
            selIndex:1,
            remark:"",
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
    },
    methods: {
        saveRemark(scope){
            statisticsSaveRemark({id:scope.Id,remark:scope.Remark},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                        }else{
                            this.$message.error(res.Message);
                        }
            })
        },
        query(){
            this.isLoading=true;
            statisticsGetDaily({
            },(res)=>{
                this.tableData=res.Result;
                this.isLoading=false;
            })
        },
        carTimeFilter(row, column) {
            const daterc = row[column.property]
            if(daterc !=null){
                return moment(daterc).format("YYYY-MM-DD")
            }
        },
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>